export default {
  methods: {
    getStatusClass(status) {
      const statusMap = {
        investigating: '-warning',
        identified: '-info',
        monitoring: '-info',
        resolved: '-success',
        error: '-danger',
        stable: '-success',
        unstable: '-danger',
        in_maintenance: '-warning',
      };

      return statusMap[status.toLowerCase()] || '-info';
    },

    translateStatus(status) {
      const translations = {
        investigating: 'Investigando',
        identified: 'Identificado',
        monitoring: 'Monitorando',
        resolved: 'Resolvido',
        in_progress: 'Em Progresso',
        fixed: 'Resolvido',
        error: 'Erro',
        stable: 'Estável',
        unstable: 'Instável',
        in_maintenance: 'Em Manutenção',
      };

      return translations[status.toLowerCase()] || status;
    },
  },
};
